.alert {
  display: flex;
  gap: 12px;
  padding: 20px;
  border: var(--outline);
  border-radius: var(--radius-card);
  background: var(--error-soft);
  color: var(--ink);
}

.icon {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  background-color: var(--error);
  -webkit-mask: url('./alert.svg') no-repeat center / contain;
  mask: url('./alert.svg') no-repeat center / contain;
}

.lines {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.text {
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
}

.retry {
  align-self: flex-start;
  min-height: 44px;
  padding: 0 18px;
  border: 2px solid var(--error);
  border-radius: var(--radius-control);
  background: var(--surface);
  color: var(--error);
  font: inherit;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}
